import type { UserRole } from '@mairistem/finances-utils';
import React from 'react';
import CalculRARModal from '../../components/simulation/Outils/CalculRARModal';
import TypeBudget from '../../constants/simulation/typeBudget';
import type Simulation from '../../interfaces/simulation/simulation';
import BaseOutil from './BaseOutil';

class CalculRAR extends BaseOutil {
	constructor() {
		super();
		this.code = 'CALC_RAR';
		this.icon = {
			iconSet: 'Lucide',
			name: 'ArrowBigRightDash',
		};
	}

	title = 'Calculer les Restes à réaliser';

	isEnabled(userRole: UserRole, simulation: Simulation) {
		return (
			super.isEnabled(userRole, simulation) &&
			!simulation?.transfertCpta &&
			simulation?.budget?.type === TypeBudget.COMPTE_ADMINISTRATIF
		);
	}

	renderModal(
		simulation: Simulation,
		onClose: () => void,
		onValidate: (data: unknown) => void,
		open: boolean,
	) {
		return (
			<CalculRARModal
				onClose={onClose}
				onValidate={onValidate}
				open={open}
				simulation={simulation}
			/>
		);
	}
}

export default CalculRAR;
